/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ParsedOSLineItem } from './ParsedOSLineItem';
/**
 * The shape returned by the Gemini parser for a single file chunk.
 * Multiple chunks are merged before being stored as `ParsedOS`.
 */
export type ParseOSResponse = {
    dates: Array<string>;
    datesInterval: ParseOSResponse.datesInterval;
    lineItems: Array<ParsedOSLineItem>;
    errors?: Array<string>;
};
export namespace ParseOSResponse {
    export enum datesInterval {
        MONTHLY = 'monthly',
        YEARLY = 'yearly',
    }
}

